import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

/**
 * セッションに関するシングルトン
 */
@Injectable({
  providedIn: "root", // globalシングルトン
})
export class SessionInfoSingleton {
  private lastOperationDatetime: number; // 最終操作日時（ミリ秒）
  private idToken: string; // IDトークン

  /** SETTER **/
  /**
   * 現在日時に更新
   */
  updateLastOperationDatetime() {
    this.lastOperationDatetime = Date.now();
  }

  setIdToken(token: string) {
    this.idToken = token;
  }

  /** GETTER **/
  getLastOperationDatetime(): number {
    return this.lastOperationDatetime;
  }

  getIdToken(): string {
    return this.idToken;
  }
}
